// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { asterisk5X5 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-asterisk': IconAsterisk;
    }
}

/**
 * The icon component for the 'asterisk' icon
 */
export class IconAsterisk extends IconSvg {
    public constructor() {
        super(asterisk5X5);
    }
}

registerIconSvg('icon-asterisk', IconAsterisk);
export const iconAsteriskTag = 'nimble-icon-asterisk';
